module.exports = __webpack_public_path__ + "fonts/Raleway-MediumItalic.b60ab149.ttf";